import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import * as Yup from "yup";

import { yupObjectValidation } from "../../../validationServices";

export const useApprovedLinkValidationSchema = () => {
  const initialValues = {
    phonenumber: "",
    password: "",
    changepassword: "",
  };

  const intl = useIntl();

  const validationSchema = {
    phonenumber: yupObjectValidation.string,
    password: Yup.string()
      .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
      .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        }),
      ),
    changepassword: Yup.string()
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        }),
      )
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          <FormattedMessage id="YUP_PASSWORD_NOT_MATCH" />,
        ),
      }),
  };

  const approvedLinkValidationSchema = Yup.object().shape(validationSchema);

  return {
    initialValues,
    approvedLinkValidationSchema,
  };
};
